import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireFeatureGate } from '~/utils/guards';

const MetaProductSelectionPage = lazy(
  () => import('~/features/content-enrichment/pages/meta-product-selection-page'),
);

/** Product selection step for the Meta Ads scheduled enrichment flow. URL: `/enrichments/meta/product-selection`. */
export const Route = createFileRoute('/_authenticated/_tenant/enrichments/meta/product-selection')({
  beforeLoad: requireFeatureGate('meta_ads'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <MetaProductSelectionPage />
    </Suspense>
  ),
});
